/* eslint-disable no-var */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/no-duplicates */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { toast } from "react-toastify";
import { CustomOption } from "components/customOption";
import MaterialUI from "../../../../material-UI";
import * as Styles from "../../styles";
import { AuthState } from "../../../../store/ducks/auth/types";
import * as SVGIcons from "../../../../assets/iconsSVG";
import {
  useDadosComplementaresV2,
  useListarEmpreendimentos2,
  useMotivosDesquealificacao,
} from "../../../../services/api";
import { useTiposResultadosTarefa } from "../../../../services/api/Mobile_Tipos_Resultados_Tarefas/tipos-empreendimentos";
import UploadButton from "../../../UploadButton";
import { useEmpreendimentosValidosSul } from "../../../../services/api/Admin_Empreendimentos/empreendimentos_validos";
import { useCorretorParceiro } from "../../../../services/api/Identity_Usuario/listar-especialistas-produto";
import { refreshTokenAzure } from "../../../../utils/auth_azure";
import Divider from "../../../Divider";
import { useMotivosAtendimento } from "../../../../services/api/AppWeb_Lead/motivos";
import { useListarObjetivosCompras } from "../../../../services/api/Mobile_ObjetivosCompras/objetivos-compras";
import { useListarProfissoes } from "../../../../services/api/DadosComum/profissoes";
import { useTemperaturasLead } from "../../../../services/api/Mobile_Temperatura_Lead/temperaturas-lead";
import { useConcluirTarefa } from "../../../../services/api/AppWeb_Lead/concluir-tarefa";

interface DataTask {
  idTarefaLead: string | null;
  titulo: string | null;
  codigoSequencial: string | null;
  tipoTarefa: string | null;
  idEmpreendimento: string | null;
  empreendimento: string | null;
  idLead: string | null;
  idLeadCorretor: string | null;
  nomeLead: string | null;
  telefonePrincipal: string | null;
  emailPrincipal: string | null;
  idTipoTarefa: string | null;
  descricao: string | null;
  dataHoraProgramadaRealizacaoTarefa: string | null;
  dataHoraConclusaoTarefa: string | null;
  codigoStatusTarefa: number | any;
  descricaoStatusTarefa: string | null;
  descricaoEtapaFunilLead: string | null;
  urlAnexo: string | null;
  tipoResultadoTarefa: string | null;
  observacao: string | null;
  tarefaInseridaOutlook: string | null;
  idTipoResultadoTarefa: string | null;
  tarefaLeadRegionalSul: string | null;
  presencaEspecialista: string | null;
  tipoDeAgendamentoVisita: 1 | 2 | 3;
  idEmpreendimentoRegionalSul: string | null;
  empreendimentoRegionalSul: string | null;
  descricaoLocalRegionalSul: string | null;
  idEtapaFunilLead: string | null;
  idCorretor: string | null;
  nomeCorretor: string | null;
  idCorretorAtendimento: string | null;
  nomeCorretorAtendimento: string | null;
}

interface Props {
  closeModal: () => void;
  idLeadCorretor: string | any;
  idLead: string | any;
  refetch: () => void;
  refetchDataLead?: () => void;
  dataLead: any;
  dataTask: DataTask;
}

interface SelectProps {
  id: string | null;
  nome: string | null;
}

interface SelectPropsCustom {
  id: string | null;
  nome: string | null;
  codigo: string | null;
}

interface FileUploadProps {
  nome: string | null;
  anexoBase64: string | null;
}

const ConcludeTaskV2: React.FC<Props> = (props) => {
  const { codigoCargo2013, codigoRegional365 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const isSul = codigoRegional365 === "2";
  const [lead, setLead] = useState<SelectProps | null>(null);
  const [empreendimento, setEmpreendimento] = useState<SelectProps | null>(
    null
  );
  const [resultado, setResultado] = useState<SelectPropsCustom | null>(null);
  const [descricaoNovaTarefa, setDescricaoNovaTarefa] = useState("");
  const [
    dataProgramadaRealizacaoTarefaConcluir,
    setDataProgramadaRealizacaoTarefaConcluir,
  ] = useState<any>(isSul ? new Date() : null);
  const [
    horaProgramadaRealizacaoTarefaConcluir,
    setHoraProgramadaRealizacaoTarefaConcluir,
  ] = useState<any>(isSul ? new Date() : null);
  const [inserirTarefaNoOutlook, setInserirTarefaNoOutlook] = useState(false);
  const [concluirTarefa] = useState(true);
  const [solicitarPresencaEspecialista, setSolicitarPresencaEspecialista] =
    useState(false);
  const [observacao, setObservacao] = useState("");
  const [fileUpload, setFileUpload] = useState<FileUploadProps | null>(null);
  const [tipoVisitaRetorno, setTipoVisitaRetorno] = useState(1);
  const [localSul, setLocalSul] = useState("");
  const [produtoSul, setProdutoSul] = useState<SelectProps | null>(null);
  const [corretorParceiro, setCorretorParceiro] = useState<SelectProps | null>(
    null
  );
  const [motivoDesqualificacao, setMotivoDesqualificacao] =
    useState<SelectProps | null>(null);
  const [profissao, setProfissao] = useState<SelectProps | null>(null);
  const [idade, setIdade] = useState<string>("");
  const [bairro, setBairro] = useState<string>("");
  const [temperatura, setTemperatura] = useState<SelectProps | null>(null);
  const [tokenAD, setTokenAD] = useState<string | null>("");
  const [motivoAtendimento, setMotivoAtendimento] =
    useState<SelectProps | null>(null);
  const [objetivoCompra, setObjetivoCompra] = useState<SelectProps | null>(
    null
  );

  const { data: dataEmpreendimento2, refetch: refetchEmpreedimentos2 } =
    useListarEmpreendimentos2();
  const {
    data: dataTiposResultadosTarefa,
    refetch: refetchTiposResultadosTarefa,
  } = useTiposResultadosTarefa({
    idTipoTarefa: props?.dataTask?.idTipoTarefa
      ? props?.dataTask?.idTipoTarefa
      : "",
    queryKey: "nova_tarefa_resultados_tarefa",
  });
  const { data: dataEmpreendimentosSul, refetch: refetchEmpreendimentosSul } =
    useEmpreendimentosValidosSul({
      queryKey: "empreendimentos_sul",
    });

  const { data: dataCorretorParceiro, refetch: refetchCorretorParceiro } =
    useCorretorParceiro({
      queryKey: "corretor_parceiro",
    });
  const {
    data: dataMotivosDesqualificacao,
    refetch: refetchMotivosDesqualificacao,
  } = useMotivosDesquealificacao({
    queryKey: "motivos_desqualificacao_tarefas",
  });
  const { data: dataMotivosAtendimento, refetch: refetchMotivosAtendimento } =
    useMotivosAtendimento({
      tipoDeAtendimento: tipoVisitaRetorno,
      queryKey: "motivos_tipo_atendimento_tarefas",
    });
  const { data: dataObjetivosCompra, refetch: refetchObjetivosCompras } =
    useListarObjetivosCompras();
  const { data: dataProfissoes, refetch: refetchProfissoes } =
    useListarProfissoes();
  const { data: dataTemperaturasLead, refetch: refetchTemperaturasLead } =
    useTemperaturasLead();

  useEffect(() => {
    setLead({
      id: props?.dataLead?.idLeadCorretor,
      nome: props?.dataLead?.nomeLead,
    });
  }, []);

  useEffect(() => {
    if (inserirTarefaNoOutlook === true) {
      requestToken();
    }
  }, [inserirTarefaNoOutlook]);

  const requestToken = async () => {
    const toJson = await localStorage.getItem("@token");
    const datas = toJson == null ? null : JSON.parse(toJson);
    if (!datas.tokenAD) {
      const tokenStorage = await refreshTokenAzure();
      setTokenAD(tokenStorage);
    } else {
      setTokenAD(datas.tokenAD);
    }
  };

  useEffect(() => {
    if (props?.dataTask?.idTipoTarefa) {
      refetchTiposResultadosTarefa();
    }
    setTipoVisitaRetorno(props.dataTask?.tipoDeAgendamentoVisita || 1);
  }, [props?.dataTask]);

  useEffect(() => {
    if (resultado?.codigo === "5") {
      refetchMotivosDesqualificacao();
    } else {
      setMotivoDesqualificacao(null);
    }
  }, [resultado]);

  useEffect(() => {
    if (resultado?.codigo === "4") {
      refetchMotivosAtendimento();
      refetchObjetivosCompras();
      refetchProfissoes();
      refetchTemperaturasLead();
      refetchDataLead();
    } else {
      setMotivoAtendimento(null);
    }
    if (resultado?.codigo === "2") {
      refetchEmpreedimentos2();
    }
    refetchCorretorParceiro();
    if (resultado?.codigo === "9" && isSul) {
      refetchEmpreendimentosSul();
      setProdutoSul({
        id: props?.dataTask?.idEmpreendimentoRegionalSul,
        nome: props?.dataTask?.empreendimentoRegionalSul,
      });
    }
  }, [resultado]);

  function formatarBase64(string: string) {
    const partes = string?.split(",");
    if (partes?.length === 2) {
      return partes[1];
    }
    return null;
  }

  const gerarIdade = (dataAtualStr: string, dataStr: string) => {
    const dataAtualParts = dataAtualStr.split("/").reverse().join("-");
    const dataNascimentoParts = dataStr.split("/").reverse().join("-");
    const dataAtual: any = new Date(dataAtualParts);
    const dataNascimento: any = new Date(dataNascimentoParts);

    const diferencaEmMilissegundos: any = dataAtual - dataNascimento;

    const idadeEmAnos = Math.floor(
      diferencaEmMilissegundos / (1000 * 60 * 60 * 24 * 365.25)
    );

    return idadeEmAnos.toString();
  };

  const {
    data: dataLead,
    refetch: refetchDataLead,
    isRefetching: isRefetchingDataLead,
    isFetched,
  } = useDadosComplementaresV2({
    idLeadCorretor: props.idLeadCorretor,
    queryKey: "dados-complementares-lead-detail-modal",
  });

  React.useEffect(() => {
    if (dataLead) {
      setProfissao({
        id: dataLead?.idProfissao ? dataLead?.idProfissao : "",
        nome: dataLead?.profissao ? dataLead?.profissao : "",
      });
      setProdutoSul({
        id: props?.dataTask?.idEmpreendimentoRegionalSul,
        nome: props?.dataTask?.empreendimentoRegionalSul,
      });
      setTemperatura({
        nome: props.dataLead?.temperaturaLead,
        id: props.dataLead?.idTemperaturaLead,
      });
      setBairro(dataLead?.bairro ? dataLead?.bairro : "");
      if (dataLead?.dataNascimento !== null) {
        const partesDataNascimento = dataLead?.dataNascimento.split("/");
        const dataNascimentoFormatada = `${partesDataNascimento[2]}-${partesDataNascimento[1]}-${partesDataNascimento[0]}`;
        setIdade(
          gerarIdade(format(new Date(), "yyyy-MM-dd"), dataNascimentoFormatada)
        );
      }
      setObjetivoCompra({
        id: dataLead?.idObjetivoCompra,
        nome: dataLead?.objetivoCompra,
      });
      setBairro(dataLead.bairro === null ? "" : dataLead.bairro);
    }
  }, [dataLead]);

  function validarData(data: any, type: "data" | "hora"): string {
    try {
      if (type === "data") {
        return format(data, "yyyy-MM-dd");
      }
      if (type === "hora") {
        return format(data, "HH:mm:ss");
      }
      throw new Error("Tipo de formato inválido. Use 'data' ou 'hora'.");
    } catch (error) {
      return "";
    }
  }

  const params = {
    idTipoResultadoTarefa: resultado?.id ? resultado?.id : null,
    idEmpreendimento: empreendimento?.id ? empreendimento?.id : null,
    observacoes: observacao,
    descricao: descricaoNovaTarefa,
    dataProgramadaRealizacaoTarefa: validarData(
      dataProgramadaRealizacaoTarefaConcluir,
      "data"
    ),
    horaProgramadaRealizacaoTarefa: validarData(
      horaProgramadaRealizacaoTarefaConcluir,
      "hora"
    ),
    idMotivoDesqualificacaoLead: motivoDesqualificacao?.id
      ? motivoDesqualificacao?.id
      : null,
    inserirTarefaNoOutlook,
    tokenAd: tokenAD,
    anexo: fileUpload,
    idProfissao365: profissao?.id ? profissao?.id : null,
    idade,
    bairro,
    codigoMotivo: motivoAtendimento?.id ? motivoAtendimento?.id : null,
    idUsuarioEspecialista: corretorParceiro?.id ? corretorParceiro?.id : null,
    idEmpreendimentoRegionalSul: produtoSul?.id ? produtoSul?.id : null,
    idTemperaturaLead365: temperatura?.id,
    idObjetivoCompra: objetivoCompra?.id ?? null,
    solicitarPresencaEspecialista,
  };

  const { mutate, isLoading, isSuccess } = useConcluirTarefa({
    idTarefaLead: props?.dataTask?.idTarefaLead
      ? props?.dataTask?.idTarefaLead
      : "",
    body: params,
  });

  const redirectPage = () => {
    window.location.href = "/transferencia-concluida/desqualificado";
  };

  useEffect(() => {
    if (isSuccess) {
      props?.closeModal();
      props?.refetch();
      if (resultado?.codigo === "5") {
        redirectPage();
      }
      if (props?.refetchDataLead) {
        props?.refetchDataLead();
      }
    }
  }, [isSuccess]);

  const validateFields = () => {
    let validationFail = false;

    if (concluirTarefa) {
      if (resultado) {
        validationFail = false;
        if (observacao?.length > 0) {
          validationFail = false;
        } else {
          validationFail = true;
          toast.error(`O campo "Observação sobre o resultado" é obrigatório`, {
            autoClose: 10000,
          });
        }
      } else {
        validationFail = true;
        toast.error(`O campo "Resultado" é obrigatório`, {
          autoClose: 10000,
        });
        return validationFail;
      }

      // Validações específicas para usuários do SUL com "Atendimento realizado"
      if (
        isSul &&
        resultado?.codigo === "4" &&
        props?.dataTask?.tipoTarefa === "Atendimento"
      ) {
        if (observacao?.length < 15) {
          validationFail = true;
          toast.error(
            `O campo "Observação sobre o resultado" deve ter no mínimo 15 caracteres`,
            {
              autoClose: 10000,
            }
          );
        }

        if (!motivoAtendimento) {
          validationFail = true;
          toast.error(`O campo "Motivo da visita" é obrigatório`, {
            autoClose: 10000,
          });
        }

        if (!corretorParceiro) {
          validationFail = true;
          toast.error(`O campo "Especialista que acompanhou" é obrigatório`, {
            autoClose: 10000,
          });
        }

        if (!objetivoCompra) {
          validationFail = true;
          toast.error(`O campo "Objetivo de compra" é obrigatório`, {
            autoClose: 10000,
          });
        }

        if (!profissao) {
          validationFail = true;
          toast.error(`O campo "Profissão" é obrigatório`, {
            autoClose: 10000,
          });
        }

        if (!bairro || bairro.trim() === "") {
          validationFail = true;
          toast.error(`O campo "Bairro residêncial" é obrigatório`, {
            autoClose: 10000,
          });
        }

        if (!idade || idade === "") {
          validationFail = true;
          toast.error(`O campo "Idade" é obrigatório`, {
            autoClose: 10000,
          });
        }

        if (!temperatura) {
          validationFail = true;
          toast.error(`O campo "Temperatura" é obrigatório`, {
            autoClose: 10000,
          });
        }
      }
    }

    return validationFail;
  };

  const handleSubmit = () => {
    if (validateFields()) {
      return;
    }
    mutate();
  };

  React.useEffect(() => {
    if (resultado?.codigo === "9" && !isSul) {
      setEmpreendimento({
        nome: props.dataTask.empreendimento,
        id: props.dataTask.idEmpreendimento,
      });
    }
  }, [resultado?.codigo]);

  function generateResultados() {
    if (dataTiposResultadosTarefa) {
      if (isSul) {
        if (
          props?.dataTask?.tipoTarefa === "Atendimento" &&
          props?.dataTask?.tipoDeAgendamentoVisita === 1
        ) {
          return dataTiposResultadosTarefa?.data
            ?.map((item: any) => ({
              id: item?.id,
              nome: item?.nome,
              codigo: item?.codigo,
              resultadoAtualizaLead: item?.resultadoAtualizaLead,
            }))
            .filter((item: any) => item.codigo === "4");
        }
        if (
          props?.dataTask?.tipoTarefa === "Atendimento" &&
          props?.dataTask?.tipoDeAgendamentoVisita === 2
        ) {
          return dataTiposResultadosTarefa?.data?.map((item: any) => ({
            id: item?.id,
            nome: item?.nome,
            codigo: item?.codigo,
            resultadoAtualizaLead: item?.resultadoAtualizaLead,
          }));
        }
        if (props?.dataTask?.tipoTarefa === "Atendimento") {
          return dataTiposResultadosTarefa?.data?.map((item: any) => ({
            id: item?.id,
            nome: item?.nome,
            codigo: item?.codigo,
            resultadoAtualizaLead: item?.resultadoAtualizaLead,
          }));
        }
      }
      return dataTiposResultadosTarefa?.data?.map((item: any) => ({
        id: item?.id,
        nome: item?.nome,
        codigo: item?.codigo,
        resultadoAtualizaLead: item?.resultadoAtualizaLead,
      }));
    }
    return [];
  }

  const canSaveSul =
    !isSul ||
    resultado?.codigo !== "4" ||
    (resultado?.codigo === "4" &&
      observacao?.length >= 15 &&
      !!motivoAtendimento &&
      !!corretorParceiro &&
      !!objetivoCompra &&
      !!profissao &&
      !!bairro &&
      !!idade &&
      !!temperatura);

  return (
    <Styles.DialogHeader
      style={{
        display: "flex",
        flex: 1,
        width: "100%",
        flexDirection: "column",
      }}
    >
      <Styles.ScrollContent maxHeight={375} minHeight={375}>
        {concluirTarefa ? (
          <>
            <Styles.RowGap>
              <Styles.Column>
                <Styles.LabelText>
                  Resultado <p>{" *"}</p>
                  <Styles.LabelIcon>
                    <SVGIcons.InfoIcon className="info-icon" />
                    <Styles.FloatText className="float-text">
                      <SVGIcons.CheckWhiteIcon className="check-icon" />
                      Resultados que atualizam o lead
                    </Styles.FloatText>
                  </Styles.LabelIcon>
                </Styles.LabelText>
                <Styles.Autocomplete
                  id="combo-box-demo"
                  fullWidth
                  options={generateResultados()}
                  value={resultado}
                  renderInput={(params: any) => (
                    <>
                      <Styles.TextField
                        size="small"
                        InputLabelProps={{ shrink: false }}
                        variant="outlined"
                        {...params}
                        label="Resultado *"
                        required
                        fullWidth
                      />
                    </>
                  )}
                  renderOption={(option) => <CustomOption option={option} />}
                  getOptionSelected={(option: any) => option?.nome}
                  getOptionLabel={(option: any) => option?.nome || ""}
                  // @ts-ignore
                  onChange={(
                    event: any,
                    newValue: {
                      id: string | null;
                      nome: string | null;
                      codigo: string | null;
                    } | null
                  ) => {
                    setResultado(newValue);
                  }}
                />
              </Styles.Column>
            </Styles.RowGap>
            {/* Acompanhamento */}
            {resultado?.codigo === "1" ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton onChangeValue={(val) => console.log(val)} />
                </Styles.RowGap>
              </>
            ) : null}
            {/* Agendou visita */}
            {resultado?.codigo === "2" ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Produto <p>*</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      options={
                        dataEmpreendimento2
                          ? dataEmpreendimento2?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={empreendimento}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Resultado *"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(
                        event: any,
                        newValue: {
                          id: string | null;
                          nome: string | null;
                        } | null
                      ) => {
                        setEmpreendimento(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Data</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>Hora</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa?.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.FormControlLabel
                    control={
                      <Styles.Checkbox
                        defaultChecked
                        checked={inserirTarefaNoOutlook}
                        onChange={() =>
                          setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                        }
                      />
                    }
                    label="Criar compromisso na agenda"
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {resultado?.codigo === "8" || resultado?.codigo === "10" ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Data</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>Hora</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa?.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.FormControlLabel
                    control={
                      <Styles.Checkbox
                        defaultChecked
                        checked={inserirTarefaNoOutlook}
                        onChange={() =>
                          setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                        }
                      />
                    }
                    label="Criar compromisso na agenda"
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {(resultado?.codigo === "3" && isSul) ||
            (resultado?.codigo === "4" && isSul) ||
            (resultado?.codigo === "6" && isSul) ||
            (resultado?.codigo === "7" && isSul) ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {/* Desqualificar */}
            {resultado?.codigo === "5" ? (
              <>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Motivo <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um tipo de atendimento",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataMotivosDesqualificacao
                          ? dataMotivosDesqualificacao?.data?.map(
                              (item: any) => ({
                                id: item?.id,
                                nome: item?.nome,
                              })
                            )
                          : []
                      }
                      value={motivoDesqualificacao}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Resultado *"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(
                        event: any,
                        newValue: {
                          id: string | null;
                          nome: string | null;
                        } | null
                      ) => {
                        setMotivoDesqualificacao(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {resultado?.codigo === "9" && !isSul ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload(
                        val?.map((item: any) => ({
                          nome: item.nome,
                          anexoBase64: formatarBase64(item.base64),
                        }))
                      )
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Data</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>Hora</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Produto</Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      disabled
                      options={
                        dataEmpreendimento2
                          ? dataEmpreendimento2?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={empreendimento}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Resultado *"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(
                        event: any,
                        newValue: {
                          id: string | null;
                          nome: string | null;
                        } | null
                      ) => {
                        setEmpreendimento(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa?.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.FormControlLabel
                    control={
                      <Styles.Checkbox
                        defaultChecked
                        checked={inserirTarefaNoOutlook}
                        onChange={() =>
                          setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                        }
                      />
                    }
                    label="Criar compromisso na agenda"
                  />
                </Styles.RowGap>
              </>
            ) : null}

            {/* SUL */}
            {/* Atendimento realizado */}
            {isSul && resultado?.codigo === "4" ? (
              <>
                <Divider text="Sobre o atendimento" />
                {/* Campos obrigatórios: Motivo da visita, Especialista que acompanhou, Objetivo de compra, 
                   Profissão, Bairro residêncial, Idade, Temperatura, Observação (mínimo 15 caracteres) */}
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      {props.dataTask?.tipoDeAgendamentoVisita === 1
                        ? "Motivo da visita"
                        : "Motivo do retorno"}{" "}
                      <p>*</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      options={
                        dataMotivosAtendimento
                          ? dataMotivosAtendimento?.data?.motivos?.map(
                              (item: any) => ({
                                id: item?.codigo,
                                nome: item?.nome,
                              })
                            )
                          : []
                      }
                      value={motivoAtendimento}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Resultado *"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(
                        event: any,
                        newValue: {
                          id: string | null;
                          nome: string | null;
                        } | null
                      ) => {
                        setMotivoAtendimento(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Especialista que acompanhou <p>*</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      options={
                        dataCorretorParceiro
                          ? dataCorretorParceiro?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={corretorParceiro}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setCorretorParceiro(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={16} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Produto de interesse</Styles.LabelText>
                    <Styles.Autocomplete
                      disabled
                      id="combo-box-demo"
                      fullWidth
                      options={
                        dataCorretorParceiro
                          ? dataCorretorParceiro?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={produtoSul}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setProdutoSul(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={16} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Objetivo de compra <p>*</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um tipo da tarefa",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataObjetivosCompra
                          ? dataObjetivosCompra?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={objetivoCompra}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setObjetivoCompra(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Divider text="Sobre o cliente" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Profissão <p>*</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      defaultValue={{
                        nome: "Selecione um tipo da tarefa",
                        id: "1",
                      }}
                      fullWidth
                      options={
                        dataProfissoes
                          ? dataProfissoes?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={profissao}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setProfissao(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Bairro residêncial <p>*</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      label="Bairro"
                      fullWidth
                      onChange={(e: any) => setBairro(e.target.value)}
                      value={bairro}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Idade <p>*</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      label="Bairro"
                      fullWidth
                      onChange={(e: any) => {
                        // Remove caracteres não numéricos
                        const value = e.target.value.replace(/\D/g, "");
                        // Garante que o valor tenha no máximo 3 dígitos
                        const idadeValue = value.slice(0, 3);
                        // Garante que o valor esteja no intervalo [0, 130]
                        const idadeNumerico = parseInt(idadeValue, 10);
                        const idadeFinal = isNaN(idadeNumerico)
                          ? ""
                          : Math.min(idadeNumerico, 130).toString();
                        // Atualiza o estado com o novo valor
                        setIdade(idadeFinal);
                      }}
                      value={idade}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Temperatura</Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      options={
                        dataTemperaturasLead
                          ? dataTemperaturasLead?.data?.map((item: any) => ({
                              id: item?.id,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={temperatura}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setTemperatura(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                {/* <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap> */}
              </>
            ) : null}
            {resultado?.codigo === "9" && isSul ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
                <Divider text="Nova tarefa" />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Data</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.DesktopDatePicker
                        inputFormat="dd/MM/yyyy"
                        value={dataProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.CalendarSelectIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setDataProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                  <Styles.Column>
                    <Styles.LabelText>Hora</Styles.LabelText>
                    <Styles.LocalizationProvider
                      locale={ptBR}
                      dateAdapter={MaterialUI.AdapterDateFns}
                    >
                      <Styles.TimePicker
                        inputFormat="HH:mm"
                        value={horaProgramadaRealizacaoTarefaConcluir}
                        components={{
                          OpenPickerIcon: SVGIcons.ClockIcon,
                        }}
                        InputAdornmentProps={{ position: "start" }}
                        onChange={(newValue: any) =>
                          setHoraProgramadaRealizacaoTarefaConcluir(newValue)
                        }
                        renderInput={(params: any) => (
                          <>
                            <Styles.TextField
                              size="small"
                              InputLabelProps={{ shrink: false }}
                              variant="outlined"
                              {...params}
                              label="Data *"
                              fullWidth
                            />
                          </>
                        )}
                      />
                    </Styles.LocalizationProvider>
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>
                      Local <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.Autocomplete
                      id="combo-box-demo"
                      fullWidth
                      disabled
                      options={
                        dataEmpreendimentosSul
                          ? dataEmpreendimentosSul?.data?.map((item: any) => ({
                              id: item?.idEmpreendimento,
                              nome: item?.nome,
                            }))
                          : []
                      }
                      value={produtoSul}
                      renderInput={(params: any) => (
                        <>
                          <Styles.TextField
                            size="small"
                            InputLabelProps={{ shrink: false }}
                            variant="outlined"
                            {...params}
                            label="Tipo da tarefa"
                            required
                            fullWidth
                          />
                        </>
                      )}
                      getOptionSelected={(option: any) => option?.nome}
                      getOptionLabel={(option: any) => option?.nome || ""}
                      // @ts-ignore
                      onChange={(event: any, newValue: any) => {
                        setProdutoSul(newValue);
                      }}
                    />
                  </Styles.Column>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                {/* <Styles.RowGap>
                  <Styles.Column>
                    <Styles.LabelText>Local</Styles.LabelText>
                    <Styles.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      label="Titulo"
                      fullWidth
                      onChange={(e: any) => setLocalSul(e.target.value)}
                      value={localSul}
                    />
                  </Styles.Column>
                </Styles.RowGap> */}
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Descrição da nova tarefa
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) =>
                        setDescricaoNovaTarefa(e.target.value)
                      }
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={descricaoNovaTarefa}
                      inputProps={{ maxLength: 4000 }}
                    />
                    <Styles.CountText>
                      {descricaoNovaTarefa?.length}/4000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.FormControlLabel
                    control={
                      <Styles.Checkbox
                        defaultChecked
                        checked={inserirTarefaNoOutlook}
                        onChange={() =>
                          setInserirTarefaNoOutlook(!inserirTarefaNoOutlook)
                        }
                      />
                    }
                    label="Criar compromisso na agenda"
                  />
                </Styles.RowGap>
                <Styles.RowGap>
                  <Styles.FormControlLabel
                    control={
                      <Styles.Checkbox
                        defaultChecked
                        checked={solicitarPresencaEspecialista}
                        onChange={() =>
                          setSolicitarPresencaEspecialista(
                            !solicitarPresencaEspecialista
                          )
                        }
                      />
                    }
                    label="Solicitar presença de um especialista"
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {(resultado?.codigo === "3" ||
              resultado?.codigo === "4" ||
              resultado?.codigo === "6" ||
              resultado?.codigo === "7") &&
            !isSul ? (
              <>
                <Styles.RowGap>
                  <Styles.MultLineField>
                    <Styles.LabelText>
                      Observação sobre o resultado <p>{" *"}</p>
                    </Styles.LabelText>
                    <Styles.TextField
                      onChange={(e: any) => setObservacao(e.target.value)}
                      label="Multiline"
                      variant="outlined"
                      fullWidth
                      multiline
                      minRows={3}
                      value={observacao}
                      inputProps={{ maxLength: 5000 }}
                    />
                    <Styles.CountText>
                      {observacao.length}/5000
                    </Styles.CountText>
                  </Styles.MultLineField>
                </Styles.RowGap>
                <Styles.SpaceY space={8} />
                <Styles.RowGap>
                  <UploadButton
                    onChangeValue={(val) =>
                      setFileUpload({
                        nome: val?.nome,
                        anexoBase64: formatarBase64(val?.base64),
                      })
                    }
                  />
                </Styles.RowGap>
              </>
            ) : null}
            {/* Desqualificar */}
          </>
        ) : null}
      </Styles.ScrollContent>
      <Styles.FooterDialog>
        <Styles.Button
          style={{ width: "100%" }}
          variant="outlined"
          onClick={() => {
            props.closeModal();
          }}
        >
          Fechar
        </Styles.Button>
        {isCorretor ? (
          <Styles.SaveButton
            onClick={() => handleSubmit()}
            style={{
              width: "100%",
              background: "#4a76fb",
              boxShadow: "none",
              color: "#fff !important",
            }}
            className={!canSaveSul || isLoading ? "disabled" : ""}
            disabled={!canSaveSul || isLoading}
          >
            {isLoading ? <BeatLoader color="#fff" size={10} /> : "Concluir"}
          </Styles.SaveButton>
        ) : null}
      </Styles.FooterDialog>
    </Styles.DialogHeader>
  );
};

export default ConcludeTaskV2;
